import React, { useState, useEffect } from 'react';
import CommissionServices from '../../services/CommissionServices';
import MembershipListServices from '../../services/MembershipListServices';
import SellerServices from '../../services/SallerServices';

function CommissionUpdate({ user, closeModal, onSuccess }) {

  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [sellers, setSellers] = useState([]);

  const [formValues, setFormValues] = useState({
    sellerId: '',
    categoryId: '',
    amount: '',
    serviceId: ''
  });

  // 🔹 Pre-fill data
  useEffect(() => {
    if (user) {
       const categoryId = user?.categoryId?._id || user?.categoryId || '';
      setFormValues({
        sellerId: user?.sellerId?._id || user?.sellerId || '',
        categoryId: user?.categoryId?._id || user?.categoryId || '',
        // serviceId: user?.serviceId?._id || '',
         serviceId: '',
        amount: user?.amount || ''
      });
        if (categoryId) {
      fetchServices(categoryId);
    }
    }
  }, [user]);
  const fetchServices = async (categoryId) => {
    try {
      const res = await MembershipListServices.membershipServiceCategory(categoryId);
      const apiData = res?.data?.data || res?.data || [];
      const formatted = (apiData || [])
        .filter(item => item?.serviceId?._id)
        .map(item => ({
          _id: item.serviceId._id,
          name: item.serviceId.title
        }));
      setServices(formatted);
    } catch (err) {
      console.log("Service fetch error:", err);
    }
  };
  useEffect(() => {
    SellerServices.getActiveSeller()
      .then(res => {
        if (res.status) {
          setSellers(res.data);
        }
      })
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await MembershipListServices.getMembershipCategory();

      const data = res?.data || [];

      const formatted = data
        .filter(item => item.name)
        .map(item => ({
          _id: item._id,
          name: item.name
        }));

      setCategories(formatted);

    } catch (err) {
      console.log("Category fetch error:", err);
    }
  };

  // 🔹 Handle change
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormValues(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };
  const getServiceId = (user) => {
  return user?.serviceId?._id || user?.serviceId || '';
};
useEffect(() => {
  if (services.length > 0 && user) {
    const selectedServiceId = getServiceId(user);
    const exists = services.find(
      s => s._id === selectedServiceId
    );

    if (exists) {
      setFormValues(prev => ({
        ...prev,
        serviceId: selectedServiceId
      }));
    }
  }
}, [services, user]);
const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "categoryId") {
    fetchServices(value);

    setFormValues(prev => ({
      ...prev,
      categoryId: value,
      serviceId: '' // reset
    }));
  } else {
    setFormValues(prev => ({
      ...prev,
      [name]: value
    }));
  }
};
  // 🔹 Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formValues.sellerId || !formValues.categoryId || !formValues.amount) {
      alert("All fields required ❗");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        sellerId: formValues.sellerId,
        categoryId: formValues.categoryId,
        serviceId: formValues.serviceId,
        amount: formValues.amount
      };

      console.log("Update Payload:", payload);

      await CommissionServices.updateSellerCommission(user._id, payload);

      alert("Commission updated successfully 🚀");

      onSuccess();
      closeModal();

    } catch (error) {
      console.error(error);

      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Update failed";

      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal fade viewbox edit-box show d-block">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header text-white">
            <h5>Update Commission</h5>
            <button className="btn-close" onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              {/* Seller */}
              <div className="mb-3">
                <label>Seller</label>
                <select
                  name="sellerId"
                  className="form-control"
                  value={formValues.sellerId}
                  onChange={handleChange}
                >
                  <option value="">Select Seller</option>
                  {sellers.map(s => (
                    <option key={s._id} value={s._id}>
                      {s.firstName} {s.lastName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Category */}
              <div className="mb-3">
                <label>Category</label>
                {/* Category */}
                <select
                  name="categoryId"
                  className="form-control"
                  value={formValues.categoryId}
                  onChange={handleChange}
                >
                  <option value="">Select Category</option>
                  {categories.map(c => (
                    <option key={c._id} value={c._id}>
                      {c.name}   
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Service</label>
                <select
                  name="serviceId"
                  className="form-control"
                  value={formValues.serviceId}
                  onChange={handleChange}
                >
                  <option value="">Select Service</option>

                  {services.map(s => (
                    <option key={s._id} value={s._id}>
                      {s.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Amount */}
              <div className="mb-3">
                <label>Amount</label>
                <input
                  type="number"
                  name="amount"
                  className="form-control"
                  value={formValues.amount}
                  onChange={handleChange}
                />
              </div>

              <button className="btn btn-success" disabled={loading}>
                {loading ? "Updating..." : "Update"}
              </button>

            </form>
          </div>

        </div>
      </div>
    </div>
  );
}

export default CommissionUpdate;